'use client'
import { useMemo } from 'react';

const useNetworkConfigurationsFromProjectSettings = ({ projectSettings, cosmosNetworkOverrides, evmNetworksOverrides, }) => useMemo(() => {
    var _a, _b, _c, _d, _e;
    const networks = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.networks;
    if (!networks)
        return {};
    const evm = networks.find((configurations) => configurations.chainName === 'evm');
    const solana = networks.find((configurations) => configurations.chainName === 'solana');
    const cosmos = networks.find((configurations) => configurations.chainName === 'cosmos');
    const starknet = networks.find((configurations) => configurations.chainName === 'starknet');
    const eclipse = networks.find((configurations) => configurations.chainName === 'eclipse');
    let cosmosNetworks = (_a = cosmos === null || cosmos === void 0 ? void 0 : cosmos.networks) === null || _a === void 0 ? void 0 : _a.map((net) => createNetwork(net, parseInt));
    cosmosNetworks = overrideNetworks(cosmosNetworkOverrides, cosmosNetworks);
    let evmNetworks = (_b = evm === null || evm === void 0 ? void 0 : evm.networks) === null || _b === void 0 ? void 0 : _b.map((net) => createNetwork(net, parseInt));
    evmNetworks = overrideNetworks(evmNetworksOverrides, evmNetworks);
    const starknetNetworks = (_c = starknet === null || starknet === void 0 ? void 0 : starknet.networks) === null || _c === void 0 ? void 0 : _c.map((net) => createNetwork(net));
    const solanaNetworks = (_d = solana === null || solana === void 0 ? void 0 : solana.networks) === null || _d === void 0 ? void 0 : _d.map((net) => createNetwork(net));
    const eclipseNetworks = (_e = eclipse === null || eclipse === void 0 ? void 0 : eclipse.networks) === null || _e === void 0 ? void 0 : _e.map((net) => createNetwork(net));
    if (evmNetworksOverrides) {
        if (Array.isArray(evmNetworksOverrides)) {
            evmNetworks = evmNetworksOverrides;
        }
        else {
            evmNetworks = evmNetworksOverrides(evmNetworks !== null && evmNetworks !== void 0 ? evmNetworks : []);
        }
    }
    const networkConfigurations = {
        cosmos: cosmosNetworks,
        eclipse: eclipseNetworks,
        evm: evmNetworks,
        solana: solanaNetworks,
        starknet: starknetNetworks,
    };
    return networkConfigurations;
}, [projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.networks, cosmosNetworkOverrides, evmNetworksOverrides]);
const createNetwork = (network, parser = (input) => input) => ({
    bech32Prefix: network.bech32Prefix,
    blockExplorerUrls: network.blockExplorerUrls,
    chainId: parser(network.chainId),
    iconUrls: network.iconUrls,
    lcdUrl: network.lcdUrl,
    name: network.name,
    nativeCurrency: network.nativeCurrency,
    networkId: parser(network.networkId),
    privateCustomerRpcUrls: network.privateCustomerRpcUrls,
    rpcUrls: network.rpcUrls,
    vanityName: network.vanityName,
});
const overrideNetworks = (networkOverrides, networks) => {
    if (!networkOverrides) {
        return networks;
    }
    if (Array.isArray(networkOverrides)) {
        return networkOverrides;
    }
    else {
        return networkOverrides(networks !== null && networks !== void 0 ? networks : []);
    }
};

export { useNetworkConfigurationsFromProjectSettings };
